import { createContext } from 'react'

export const WorkspaceLayoutContext = createContext(false)
